import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { history } from './utils';
// import PostPaidHome2  from './containers/PostPaidFlow/Home2'

import APP_ROUTES_CONSTANT from 'constants/appRouteConstants';

// the webpack prefetch comment is a magic comment api
// that tells webpack to load the file after rendering the main home page
// This helps in preventing showing the loading screen on each route change

/* General Screens */
const KnowMore = lazy(() => import( /* webpackPrefetch: true */ './containers/General/KnowMore'));
const DetailedFAQ = lazy(() => import( /* webpackPrefetch: true */ './containers/General/DetailedFAQ'));
const FAQ = lazy(() => import( /* webpackPrefetch: true */ './containers/General/FAQ'));
const ReferNEarn = lazy(() => import( /* webpackPrefetch: true */ './containers/General/ReferNEarn'));
const ReferralContactList = lazy(() => import( /* webpackPrefetch: true */ './containers/General/ReferralContactList'));
const SomethingWentWrong = lazy(() => import( /* webpackPrefetch: true */ './containers/General/SomethingWentWrong'));
const TNC = lazy(() => import( /* webpackPrefetch: true */ './containers/General/TNC'));
const Profile = lazy(() => import( /* webpackPrefetch: true */ './containers/General/Profile'));
const Rating = lazy(() => import( /* webpackPrefetch: true */ './containers/General/Rating'));
const PostpeVideos = lazy(() => import ( /* webpackPrefetch: true */ './containers/General/PostpeVideos'))
const PrivacySettings = lazy(() => import ( /* webpackPrefetch: true */ './containers/General/PrivacySettings'))
const ClosedAccount= lazy(() => import ( /* webpackPrefetch: true */ 'containers/OnBoardingFlow/Closed'))
const ArcUsers= lazy(() => import ( /* webpackPrefetch: true */ 'containers/PostPaidFlow/ARCUsers'))
const ARCUsersApplication =  lazy(() => import ( /* webpackPrefetch: true */ 'containers/PostPaidFlow/ARCUsers/application'))
const Loans =  lazy(() => import ( /* webpackPrefetch: true */ './containers/PostPaidFlow/loans'))
const AuCreditCard =  lazy(() => import ( /* webpackPrefetch: true */ './containers/General/AuCreditCard'))
const StayTuned = lazy(() => import ('./containers/General/StayTuned'))

/* Onboarding screens */
const Landing = lazy(() => import(/* webpackPrefetch: true */ './containers/Landing'));
const Waitlist = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/Waitlist'));
const TopBanks = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/TopBanks'));
const LoanSanction = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/LoanSanction'));
const BalanceLetter = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/BalanceLetter'));
const EnterPan = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/EnterPan'));
const VerifyPan = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/VerifyPan'));
const KycError = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/KycError'));
const BankList = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/BankList'));
const AdditionalDetailsEmail = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/AdditionalDetails/Email'),
);
const AdditionalDetailsAddress = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/AdditionalDetails/Address'),
);
const UpgradeOnBoardingPage = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/UpgradeOnboarding'),
);
const Agreement = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/Agreement'));
const LenderProcess = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/Agreement/LenderProcess'),
);
const AnnualIncome = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/AnnualIncome'));
const ReferenceList = lazy(() => import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/ReferenceList'));
const UpgradeScreenTemp = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/UpgradeScreenTemp'),
);
const CheckLoanEligibility = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/Dsa/CheckLoanEligibility'),
);
const ActivationProgress = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/OnBoardingFlow/ActivationProgress'),
);

/* Send money Screens */
const SendMoneyAmountInsertion = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/SendMoneyFlow/AmountInsertion'),
);
const SendMoneyBankList = lazy(() => import(/* webpackPrefetch: true */ './containers/SendMoneyFlow/BankList'));
const SendMoneyHome = lazy(() => import(/* webpackPrefetch: true */ './containers/SendMoneyFlow/Home'));
const SendMoneyOwnBanks = lazy(() => import(/* webpackPrefetch: true */ './containers/SendMoneyFlow/OwnBanks'));
const SendMoneyTopBanks = lazy(() => import(/* webpackPrefetch: true */ './containers/SendMoneyFlow/TopBanks'));
/* Transaction Screens */
const TransactionList = lazy(() => import(/* webpackPrefetch: true */ './containers/TransactionFlow/TransactionList'));
const TransactionStatus = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/TransactionFlow/TransactionStatus'),
);

/* Received Limit Screens */
const ReceivedLimitAmountInsertion = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/ReceivedLimitFlow/AmountInsertion'),
);
const ReceivedLimitComingSoon = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/ReceivedLimitFlow/ComingSoon'),
);
const ReceivedLimitMerchantBanks = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/ReceivedLimitFlow/MerchantBanks'),
);
const ReceivedLimitMerchantMobile = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/ReceivedLimitFlow/MerchantMobile'),
);
const ReceivedLimitTabs = lazy(() => import(/* webpackPrefetch: true */ './containers/ReceivedLimitFlow/Tabs'));
/* PostPaid Screens */
const PostPaidHome2 = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/Home2'));
const PostPaidRepaymentHistory = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/RepaymentHistory'),
);
const PostPaidBillHistory = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/BillHistory'));
const PostPaidAmountInsertion = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/AmountInsertion'),
);
const PostPaidBillView = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/BillView'));
const PostPaidCashback = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/Cashback'));
const PostPaidComingSoon = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/ComingSoon'));
const PostPaidEmiConversion = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/EmiConversion'));
const PostPaidMerchantBanks = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/MerchantBanks'));
const PostPaidMerchantMobile = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/MerchantMobile'),
);
const PostPaidAccountDetailsEdit = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/AccountDetailsEdit'),
);
const PostPaidAccountDetails = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/AccountDetails'),
);
// const PostPaidTabs = lazy(() => import( /* webpackPrefetch: true */ './containers/PostPaidFlow/Tabs'));
const PostPaidCardView = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/CardView'));
const LimitManagement = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/LimitManagement'));
const PostPaidOfferDetails = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/OfferDetails'));
const PostPaidOffers = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/OffersView'));
const Survey = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/Survey'));
const Charges = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/Charges'));
const QRCharges = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/QRCharges'));
const AgreementLetter = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/AgreementLetter'));
const LenderUpgrade = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/LenderUpgrade'));
const LenderMigration = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/LenderMigration'));
const CardBlock = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/CardBlock'));
const CardExpired = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/CardExpired'));
const CardClosure = lazy(() => import(/* webpackPrefetch: true */ './containers/PostPaidFlow/CardClosure'));
const ConsumerDurableLoan = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/AmountInsertion/ConsumerDurableLoan'),
);

/* Credit Card Screens */
const CreditCardList = lazy(() => import(/* webpackPrefetch: true */ './containers/CreditCardFlow/CreditCardList'));
// const CreditCardListOld = lazy(() => import( /* webpackPrefetch: true */ './containers/CreditCardFlow/oldFlow/CreditCardList'));
const CreditCardTNC = lazy(() => import(/* webpackPrefetch: true */ './containers/CreditCardFlow/Terms&Condition'));
const CreditCardTxnList = lazy(() => import(/* webpackPrefetch: true */ './containers/CreditCardFlow/TransactionList'));
const CreditCardTxnDetail = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/CreditCardFlow/TransactionStatus'),
);
const CreditCardAmountInsertion = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/CreditCardFlow/AmountInsertion'),
);
// const CreditCardAmountInsertionOld = lazy(() => import( /* webpackPrefetch: true */ './containers/CreditCardFlow/oldFlow/AmountInsertion'));
const KnowMoreAsPostpe = lazy(() => import(/* webpackPrefetch: true */ './containers/CreditCardFlow/KnowMoreAsPostpe'));
const SecureCard = lazy(() => import(/* webpackPrefetch: true */ './containers/CreditCardFlow/SecureCard'));
const EmergencyFundEducation = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/CreditCardList/EmergencyFund/EmergencyFundEducation'),
);
const CcbpOwnBanks = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/OwnBanks'),
);
const CcbpTopBanks = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/TopBanks'),
);
const CcbpAllBanks = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/AllBanks'),
);
const CcbpSelectAccount = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/SelectAccount'),
);
const CcbpStatus = lazy(() => import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/Status'));
const CcbpPendingPayments = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/PendingPayments'),
);

const Rewards = lazy(() => import(/* webpackPrefetch: true */ './containers/CashbackRewardsFlow/Rewards'));
const InitiatePayment = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/CreditCardFlow/PayViaSendMoney/InitiatePayment'),
);
const CdlIntroScreen = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/PostPaidFlow/AmountInsertion/CdlIntroScreen'),
);

const SuperAppMigration = lazy(() => import(/* webpackPrefetch: true */ 'containers/General/SuperAppMigration'));
const SuperAppMigrationInProgress = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/General/SuperAppMigration/SuperAppMigrationPending'),
);
const SuperAppMigrationFailed = lazy(() =>
	import(/* webpackPrefetch: true */ 'containers/General/SuperAppMigration/SuperAppMigrationFailed'),
);

const ActiveAccountFound = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/DeleteAccount/ActiveAccountFound'),
);
const AccountDeleted = lazy(() =>
	import(/* webpackPrefetch: true */ './containers/PostPaidFlow/DeleteAccount/AccountDeleted'),
);

const AppRouter = () => {
	return (
		<Router history={history}>
			<Suspense fallback={<></>}>
				<Switch>
					{/* General */}
					<Route exact path="/" component={Landing} />

					<Route path={APP_ROUTES_CONSTANT.faqs.faq} component={FAQ} />
					<Route path={APP_ROUTES_CONSTANT.faqs.detailed} component={DetailedFAQ} />
					<Route path={APP_ROUTES_CONSTANT.somethingWrong} component={SomethingWentWrong} />
					<Route path="/tnc" component={TNC} />
					<Route path="/refernearn" component={ReferNEarn} />
					<Route path="/referral-contact-list" component={ReferralContactList} />
					<Route path="/know-more/:flowType?" component={KnowMore} />
					<Route path="/profile" component={Profile} />
					<Route path="/agreement" component={AgreementLetter} />
					<Route path="/charges" component={Charges} />
					<Route path="/qr-charges" component={QRCharges} />
					<Route path="/lender-upgrade" component={LenderUpgrade} />
					<Route path="/lender-migration" component={LenderMigration} />
					<Route path="/postpe-videos" component={PostpeVideos}/>
					<Route path="/rating" component={Rating}/>
					<Route path="/privacy-settings" component={PrivacySettings}/>
					<Route path="/closed" component={ClosedAccount}/>
					<Route path="/stayTuned" component={StayTuned}/>
					<Route path="/arcUsers" component={ArcUsers}/>
					<Route path='/arcApplication' component={ARCUsersApplication}/>
					<Route path="/cashback-rewards" component={Rewards}/>
					<Route path="/au-credit-card" component={AuCreditCard}/>
					<Route path="/super-app-migration" component={AuCreditCard}/>
					<Route path="/super-app-migration-ll" component={SuperAppMigration} />
					<Route path="/super-app-migration-inprogress" component={SuperAppMigrationInProgress} />
					<Route path="/super-app-migration-failed" component={SuperAppMigrationFailed} />

					{/* Credit Card Flow */}
					{/* <Route path="/credit-card-tnc" component={CreditCardTNC} />
					<Route path="/credit-card-postpe-tnc" component={KnowMoreAsPostpe} />
					<Route path="/emergency-fund-education" component={EmergencyFundEducation} />
					<Route path="/credit-card-list" component={CreditCardList} />

					<Route path="/credit-card-txnList" component={CreditCardTxnList} />


					<Route path="/credit-card-txnDetail" component={CreditCardTxnDetail} />
					<Route path="/credit-card-txnDetail2" component={CreditCardTxnDetail} />
					<Route path="/credit-card/amount-insertion" component={CreditCardAmountInsertion} />

					<Route path='/credit-card/secure-card' component={SecureCard}/>
					<Route path="/credit-card/pay-via-send-money/initiate" component={InitiatePayment} />
					<Route path="/credit-card/pay-via-send-money/own-banks" component={CcbpOwnBanks} />
					<Route path="/credit-card/pay-via-send-money/top-banks" component={CcbpTopBanks} />
					<Route path="/credit-card/pay-via-send-money/all-banks" component={CcbpAllBanks} />
					<Route path="/credit-card/pay-via-send-money/select-account" component={CcbpSelectAccount} />
					<Route path="/credit-card/pay-via-send-money/status" component={CcbpStatus} />
					<Route path="/credit-card/pay-via-send-money/pending-payments" component={CcbpPendingPayments} /> */}
					<Route path="/credit-card-tnc" component={StayTuned} />
					<Route path="/credit-card-postpe-tnc" component={StayTuned} />
					<Route path="/emergency-fund-education" component={StayTuned} />
					<Route path="/credit-card-list" component={StayTuned} />

					<Route path="/credit-card-txnList" component={StayTuned} />

					<Route path="/credit-card-txnDetail" component={StayTuned} />
					<Route path="/credit-card-txnDetail2" component={StayTuned} />
					<Route path="/credit-card/amount-insertion" component={StayTuned} />

					<Route path="/credit-card/secure-card" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/initiate" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/own-banks" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/top-banks" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/all-banks" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/select-account" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/status" component={StayTuned} />
					<Route path="/credit-card/pay-via-send-money/pending-payments" component={StayTuned} />

					{/* OnBoarding Flow */}
					<Route path="/onboarding/enter-pan" component={EnterPan} />
					<Route path="/onboarding/top-banks" component={TopBanks} />
					<Route path="/onboarding/bank-list" component={BankList} />
					<Route path="/onboarding/waitlist" component={Waitlist} />
					<Route path="/onboarding/kyc-error" component={KycError} />
					<Route path={APP_ROUTES_CONSTANT.onboarding.upgrade} component={UpgradeOnBoardingPage} />
					<Route path="/onboarding/loan-sanction" component={LoanSanction} />
					<Route path="/onboarding/balance-transfer" component={BalanceLetter} />
					<Route path="/onboarding/additional-details-email" component={AdditionalDetailsEmail} />
					<Route path="/onboarding/additional-details-address" component={AdditionalDetailsAddress} />
					<Route path="/onboarding/verify-pan" component={VerifyPan} />
					<Route path="/onboarding/agreement" component={Agreement} />
					<Route path="/onboarding/lender-process" component={LenderProcess} />
					<Route path="/onboarding/annual-income" component={AnnualIncome} />
					<Route path="/onboarding/add-reference" component={ReferenceList} />
					<Route path="/onboarding/check-loan-eligibility" component={CheckLoanEligibility} />
					<Route path="/onboarding/upgrade" component={UpgradeScreenTemp} />
					<Route path="/onboarding/activation-progress" component={ActivationProgress} />

					{/* Received Limit Flow */}
					<Route path="/received-limit/amount-insertion" component={ReceivedLimitAmountInsertion} />
					<Route path="/received-limit/home" component={ReceivedLimitTabs} />
					<Route path="/received-limit/merchant-mobile" component={ReceivedLimitMerchantMobile} />
					<Route path="/received-limit/merchant-banks" component={ReceivedLimitMerchantBanks} />
					<Route path="/received-limit/coming-soon" component={ReceivedLimitComingSoon} />

					{/* PostPaid Flow */}
					<Route path="/postpaid/cashback" component={PostPaidCashback} />
					<Route path="/postpaid/amount-insertion" component={PostPaidAmountInsertion} />
					<Route path="/postpaid/cdl-intro" component={CdlIntroScreen} />
					<Route path="/postpaid/merchant-mobile" component={PostPaidMerchantMobile} />
					<Route path="/postpaid/merchant-banks" component={PostPaidMerchantBanks} />
					<Route path="/postpaid/bill-view" component={PostPaidBillView} />
					<Route path="/postpaid/emi-conversion" component={PostPaidEmiConversion} />
					<Route path="/postpaid/coming-soon" component={PostPaidComingSoon} />
					<Route path="/postpaid/repayment-history" component={PostPaidRepaymentHistory} />
					<Route path="/postpaid/bill-history" component={PostPaidBillHistory} />
					<Route path="/postpaid/loans" component={Loans} />
					<Route path="/postpaid/limit-management" component={LimitManagement} />
					<Route path="/postpaid/offers" component={PostPaidOffers} />
					<Route path="/postpaid/offer-details" component={PostPaidOfferDetails} />
					<Route path="/postpaid/view-card" component={PostPaidCardView} />
					<Route path="/postpaid/account-details" component={PostPaidAccountDetails} />
					<Route path="/postpaid/account-details-edit" component={PostPaidAccountDetailsEdit} />
					<Route path="/postpaid/survey" component={Survey} />
					<Route path="/postpaid/block-card" component={CardBlock} />
					<Route path="/postpaid/expired-card" component={CardExpired} />
					<Route path="/postpaid/card-closed" component={CardClosure} />
					<Route path="/postpaid/consumer-durable-loan" component={ConsumerDurableLoan} />

					{/* Send Money Flow */}
					<Route path="/send-money/home" component={SendMoneyHome} />
					<Route path="/send-money/amount-insertion" component={SendMoneyAmountInsertion} />
					<Route path="/send-money/top-banks" component={SendMoneyTopBanks} />
					<Route path="/send-money/bank-list" component={SendMoneyBankList} />
					<Route path="/send-money/own-banks" component={SendMoneyOwnBanks} />

					{/* Transactions Flow */}
					<Route path="/transaction-list" component={TransactionList} />
					<Route path="/transaction-status" component={TransactionStatus} />

					{/* Delete Acocunt Flow */}
					<Route path="/active-account-found" component={ActiveAccountFound} />
					<Route path="/account-deleted" component={AccountDeleted} />

					<Route path={APP_ROUTES_CONSTANT.postpaid.home} component={PostPaidHome2} />
				</Switch>
			</Suspense>
		</Router>
	);
};
export default AppRouter;
